// extracted by mini-css-extract-plugin
export default {"viewBtn":"Button_viewBtn__81o29"};